import { useState, useEffect } from 'react';
import { steemCustomApi } from 'services/dsteem-service'; 
import { useAuth } from './authContext';

function useCategories() {
  const { user } = useAuth();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchCategories() {
      console.log("Getting categories for",user);
      try { 
        if (user) {
          let response;
          try {
            response = await steemCustomApi("bridge.list_all_subscriptions", {account:user});
          } catch (error) {
            console.log("while getting categories", error);
            setError("while getting categories");
            return;
          }
          
          if (response && Array.isArray(response)) {
            const sorted = response.slice().sort((a, b) => {
              const nameA = (Array.isArray(a) && a[1]) ? String(a[1]) : '';
              const nameB = (Array.isArray(b) && b[1]) ? String(b[1]) : '';
              return nameA.localeCompare(nameB, 'es', { sensitivity: 'base', numeric: true });
            }); 
            setCategories(sorted);
          } else {
            setError('Failed to fetch categories.');
          }

        }else {
          console.log('No user logged, skipping'); 
        }
        
      } catch (err) {
        setError(err.message || 'An error occurred.');
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, [user]);

  return { categories, loading, error };
}

export default useCategories;